
import { decideIntegrationForProvider } from "../../_helpers/utils";
import { ENABLE_THIRD_PARTY_INTEGRATION_MODAL_CONTENT } from "../../constants/thirdParty";

let state = {
  open: false,
  provider: null,
  modalDetails: null,
  template: null,
  pendingPayload: null,
  onAllowed: null,
};

const listeners = new Set();

export const getState = () => state;

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(state);
    } catch (err) {
      console.error("integrationGate listener error", err);
    }
  });
}

export const subscribe = (fn) => {
  listeners.add(fn);
  // deliver current state immediately
  try {
    fn(state);
  } catch (err) {
    console.error("integrationGate initial listener error", err);
  }
  return () => listeners.delete(fn);
};

export const openModal = ({ provider, modalDetails, template, pendingPayload, onAllowed }) => {
  state = {
    open: true,
    provider,
    modalDetails,
    template,
    pendingPayload,
    onAllowed,
  };
  notify();
};

export const closeModal = () => {
  state = {
    open: false,
    provider: null,
    modalDetails: null,
    template: null,
    pendingPayload: null,
    onAllowed: null,
  };
  notify();
};

/**
 * Main API used by components. Returns { allowed: boolean }.
 * If allowed === true the caller should proceed synchronously.
 * If allowed === false, the manager will open modal and call onAllowed when integration succeeds.
 */
export const requestIntegrationForTemplate = ({
  providerRaw,
  template = null,
  isAdmin = false,
  connectedAccounts = [],
  authorisedApps = [],
  pendingPayload = null,
  onAllowed = null,
}) => {
  const providerKey = providerRaw || template?.data_source?.provider;

  const { stopCreating, modalContent } = decideIntegrationForProvider({
    providerKey,
    isAdmin,
    connectedAccountsArr: connectedAccounts,
    authorisedAppsArr: authorisedApps,
  });

  if (!stopCreating) {
    if (typeof onAllowed === "function") onAllowed();
    return { allowed: true };
  }

  openModal({
    provider: providerKey,
    modalDetails: modalContent || ENABLE_THIRD_PARTY_INTEGRATION_MODAL_CONTENT?.[providerKey]?.[0],
    template,
    pendingPayload,
    onAllowed,
  });

  return { allowed: false };
};
